import { coreConstants } from "../constants/core.constants";

const initialState = {
  fetching: false,
  request: null,
  fetched: false,
  response: null,
  error: null
};

export const coreDomains = (state = initialState, action) => {
  switch (action.type) {
    case coreConstants.GET_CORE_DOMAINS_REQUEST:
      return {
        ...state,
        request: action.requestParams,
        fetching: true
      };
    case coreConstants.GET_CORE_DOMAINS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response && action.response.modelList,
        error: null
      };
    case coreConstants.GET_CORE_DOMAINS_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case coreConstants.GET_CORE_DOMAINS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
